import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { CollapsibleBox } from '@/components/collapsible'
import {
  Label,
  FieldInput,
  FieldDropdown,
  FieldSwitchToggle,
  FieldTextarea
} from '@/components/form'
import { FormGrid, FormRow } from '../../elements'

const ParkingSection = () => {
  const { t } = useTranslation()
  const { setFieldValue, values: data } = useFormikContext()

  const toggleHasFee = value => {
    setFieldValue('parking.hasFee', value)
    setFieldValue('parking.fee_frequency_txt_id', value ? '' : 'free')
  }

  return (
    <CollapsibleBox
      title={t('l.contract.edit.parking_info.label', 'Parking Info')}
      top={40}
      maxLength={22}
    >
      <FormGrid>
        <FormRow>
          <Label noGutter bottom="0">
            {t('l.contract.edit.parking_included.label', 'Parking included')}
          </Label>
          <FieldSwitchToggle name="parking.enabled" />
        </FormRow>
        {data.parking.enabled && (
          <>
            <FormRow>
              <Label noGutter bottom="0">
                {t('l.contract.edit.parking_fee.label', 'Parking fee')}
              </Label>
              <FieldSwitchToggle name="parking.hasFee" onChange={toggleHasFee} />
            </FormRow>
            {data.parking.hasFee && (
              <>
                <div>
                  <FieldInput
                    name="parking.fee"
                    placeholder={t(
                      'l.contract.edit.parking_fee_amount.label',
                      'Parking fee amount'
                    )}
                    required
                    prefix="$"
                    transform={val => (val ?? '').replace(/[^0-9.]/g, '')}
                  />
                </div>
                <div>
                  <FieldDropdown
                    name="parking.fee_frequency_txt_id"
                    placeholder={t('l.contract.edit.payment_frequency.label', 'Payment frequency')}
                    required
                    options={[
                      {
                        value: 'weekly',
                        label: t('common.frequency_weekly', 'Weekly')
                      },
                      {
                        value: 'monthly',
                        label: t('common.frequency_monthly', 'Monthly')
                      },
                      {
                        value: 'one_time',
                        label: t('common.frequency_one_time', 'One-time')
                      }
                    ]}
                  />
                </div>
              </>
            )}
            <FormRow>
              <FieldTextarea
                name="parking.name"
                maxLength={250}
                height={115}
                placeholder={t('l.contract.edit.write_info.placeholder', 'Write additional info')}
              />
            </FormRow>
          </>
        )}
      </FormGrid>
    </CollapsibleBox>
  )
}

export default ParkingSection
